// extracted by mini-css-extract-plugin
var _1 = "SidebarSections-module__add--cFGBZ";
var _2 = "SidebarSections-module__addWrapper--tVsGa";
var _3 = "SidebarSections-module__animateUploadProgressBarWidth--iduvQ";
var _4 = "SidebarSections-module__animatedBackground--lPAXr";
export { _1 as "add", _2 as "addWrapper", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground" }
